module.exports = __webpack_public_path__ + "media/KZ-SEV.f3ea7785.ogg";